import {
  red,
  green,
  orange,
} from '@material-ui/core/colors';

/**
   * Estilos basados en:
   *
   * https://material-ui.com/customization/color/
*/

export default {
  activo: {
    background: green[500],
    color: 'white',
  },
  inactivo: {
    background: red[500],
    color: 'white',
  },
  aprobado: {
    background: green[600],
    color: 'white',
  },
  publicado: {
    background: green[600],
    color: 'white',
  },
  pendiente: {
    background: orange[500],
    color: 'white',
  },
  pagado: {
    background: green[500],
    color: 'white',
  },
  'no-pagado': {
    background: red[500],
    color: 'white',
  },
  'no-aprobado': {
    background: red[500],
    color: 'white',
    '&:hover': {
      background: red[700],
    },
  },
  'no-publicado': {
    background: red[500],
    color: 'white',
    '&:hover': {
      background: red[700],
    },
  },
};
